// extracted by mini-css-extract-plugin
export var branded = "OdyqeLF8uPMk6kwrfNUr";
export var root = "pWtVSPSNeNeIMozj4nno";
export var spin = "MWJYlHi3XchCQ5c5Pn1e";